export default "__VITE_ASSET__Ccb97Mgx__"